var React = require('react');

function MenuIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"layer1","transform":"translate(-164.991,-200.04762)"},React.createElement("g",{"id":"g3514","transform":"matrix(4.8104881,0,0,4.1794047,3.2672039,110.24893)"},[React.createElement("rect",{"id":"rect3498","width":"56.292","height":"10.118","x":"33.618999","y":"21.486","key":0}),React.createElement("rect",{"id":"rect3502","width":"56.292","height":"10.118","x":"33.618999","y":"46.159","key":1}),React.createElement("rect",{"id":"rect3506","width":"56.292","height":"10.117","x":"33.618999","y":"70.974998","key":2})])));
}

MenuIcon.defaultProps = {"viewBox":"0 0 270.79198 249.11758"};

module.exports = MenuIcon;

MenuIcon.default = MenuIcon;
